"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeader = void 0;
var classNames = require("classnames");
var React = require("react");
var Table_1 = require("@caddigital/sok-ui/lib/components/Table");
var types_1 = require("@caddigital/sok-reducers/lib/types");
var ColumnFilter_1 = require("components/ColumnFilter");
var list_1 = require("utils/list");
var createHeaderCell = function (key, props) {
    var _a, _b;
    var column = props.columns[key];
    var caption = (_a = column === null || column === void 0 ? void 0 : column.caption) !== null && _a !== void 0 ? _a : '-';
    var width = (_b = column === null || column === void 0 ? void 0 : column.pixelWidth) !== null && _b !== void 0 ? _b : 0;
    var filterInputValue = props.filterOptions[key];
    var isFilterActive = filterInputValue !== undefined;
    var sortOrder = props.orderByOptions.orderBy === key
        ? props.orderByOptions.order
        : undefined;
    var nextSortOrder = sortOrder === types_1.ASC ? types_1.DESC : types_1.ASC;
    return (React.createElement("div", { key: key, className: 'row__column', style: (0, list_1.createCellStyle)(width) },
        React.createElement("div", { onClick: function () { return props.sortBy(key, nextSortOrder); } }, caption),
        React.createElement(Table_1.SortButton, { className: classNames('sort', 'd-none', 'd-desktop-table-cell'), order: sortOrder, onChange: function () { return props.sortBy(key, nextSortOrder); } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames('filter', isFilterActive && 'active'), columnIdentifier: key, inputType: 'text', textInputValue: filterInputValue !== null && filterInputValue !== void 0 ? filterInputValue : '', setColumnFilterString: function (_, value) { return props.filterBy(key, value); }, clearColumnFilter: function () { return props.filterBy(key, undefined); } })));
};
var component = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style }, Object.keys(props.columns).map(function (key) {
        return createHeaderCell(key, props);
    })));
};
exports.ListHeader = component;
